import React from 'react';
import { Heatmap } from 'react-hour-heatmap';
import { Card, CardHeader, CardContent, Divider } from "@material-ui/core";
export default {
  React,
  Heatmap,
  Card,
  CardHeader,
  CardContent,
  Divider
};